module.exports = __webpack_public_path__ + "img/c2f47f20-00b4-4cec-b972-e7a69d40be56.61712eb2.webp";